import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
  static targets = ['toast']
  static values = {
    maxToasts: { default: 5, type: Number }
  }

  toastTargetConnected() {
    if (this.toastTargets.length > this.maxToastsValue)
      this.#removeOldestToast()
  }

  #removeOldestToast() {
    this.toastTargets[0].remove()
  }
}
